// User & Auth Status
export const USER_NOT_FOUND = 'USER_NOT_FOUND';
export const USER_NOT_ACTIVE = 'USER_NOT_ACTIVE';
export const PASSWORD_MISMATCH = 'PASSWORD_MISMATCH';
export const PASSWORD_INVALID = 'PASSWORD_INVALID';
export const INCORRECT_CREDENTIALS = 'INCORRECT_CREDENTIALS';
export const USERNAME_PASSWORD_BLANK = 'USERNAME_PASSWORD_BLANK';
export const VALID_AUTHENTICATION = 'VALID_AUTHENTICATION';

// Repair Status
export const ORDER_NOT_FOUND = 'ORDER_NOT_FOUND';
export const REPAIR_VALIDATION_ERROR = 'REPAIR_VALIDATION_ERROR';
export const REPAIR_CREATION_FAILED = 'REPAIR_CREATION_FAILED';
export const INVALID_REPAIR_ORDER_SEARCH = 'INVALID_REPAIR_ORDER_SEARCH';

// Order Payment
export const CANT_LOWER_ORDER_PAYMENT = 'CANT_LOWER_ORDER_PAYMENT';
export const PAYMENT_VALIDATION_ERROR = 'PAYMENT_VALIDATION_ERROR';
export const ORDER_ALREADY_PAID = 'ORDER_ALREADY_PAID';

// Order Status
export const ORDERER_TWICE = 'ORDERER_TWICE';
export const ORDER_NOT_PAID = 'ORDER_NOT_PAID';
export const CANT_RESTATUS_ORDER = 'CANT_RESTATUS_ORDER';
export const ORDER_CANCELED = 'ORDER_CANCELED';
export const ORDER_DELIVERED = 'ORDER_DELIVERED';
export const ORDER_UPDATE_VALIDATION_ERROR = 'ORDER_UPDATE_VALIDATION_ERROR';